import { DashBoardOwnPageComponent } from './components/dashboard-ownpage.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

import { DashboardComponent } from './dashboard.component';
import { DashboardService } from './Services/dashboard.services';
import {
  DashboardActivityResolver,
  DashboardDeviationResolver,
  DashboardRiskAnalysisResolver,
  DashboardNewsResolver,
  DashboardBusinessResolver,
  DashboardLoggedUserResolver,
  DashboardAboutKubaResolver,
  DashboardAppLoggedUserResolver,
  DashboardLinksListResolver,
  DashboardBusinessFunctionResolver,
  AboutKubaIKResolver,
  DashboardAdminNewsResolver,
  DashboardDeviationCountForUsers,
  DashboardLinksPortalBusinessResolver,
  DashboardLinksForPortalBusinessResolver,
  DashboardBusinessLoginResolver
} from './Services/dashboard.resolver.service';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { AppSharedModule } from './../shared/appShared.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DashboardDeviationChartComponent } from './components/deviation-widget/deviation-widget.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RiskAnalysisWidgetComponent } from './components/risk-analysis-business-widget/risk-analysis-business-widget.component';
import { RiskAnalysisAdminAndPortalWidgetComponent } from './components/risk-analysis-portal-widget/risk-analysis-portal-widget.component';
import { RiskGaugeComponent } from './components/risk-gauge/risk-gauge.component';
import { ActivitiesWidgetComponent } from './components/activities-business-widget/activities-business-widget.component';
import { ActivitiesPortalWidgetComponent } from './components/activities-portal-widget/activities-portal-widget.component';
import { FlexiCompliancePortalWidgetComponent } from './components/flexi-compliance-portal-widget/flexi-compliance-portal-widget.component';
import { FlexiCompliancePortalListComponent } from './components/flexi-compliance-portal-list/flexi-compliance-portal-list.component';
import { FlexiComplianceBusinessWidgetComponent } from './components/flexi-compliance-business-widget/flexi-compliance-business-widget.component';
import { FlexiComplianceActionPointsWidgetComponent } from './components/flexi-compliance-action-points-widget/flexi-compliance-action-points-widget.component';
import { DialogMeetingsWidgetComponent } from './components/dialog-meetings-widget/dialog-meetings-widget.component';
import { ChemicalsSdsWidgetComponent } from './components/chemicals-sds-widget/chemicals-sds-widget.component';
import { MyActivitiesWidgetComponent } from './components/my-activities-widget/my-activities-widget.component';
import { MyDeviationsWidgetComponent } from './components/my-deviations-widget/my-deviations-widget.component';
import { AdminNewsViewerComponent } from './components/admin-news-viewer/admin-news-viewer.component';
import { AppraisalMeetingService } from '../employees/appraisals/meetings/services/appraisal-meeting.service';
import { AppraisalSettingsService } from '../employees/appraisals/settings/services/appraisal-settings.service';
@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    TreeModule,
    AppSharedModule,
    RouterModule,
    BsDatepickerModule,
    FullCalendarModule,
    TranslatePipe, TranslateDirective,
    TooltipModule,
    NgxChartsModule
  ],
  exports: [DashboardComponent],
  declarations: [
    DashboardComponent,
    DashBoardOwnPageComponent,
    DashboardDeviationChartComponent,
    RiskAnalysisWidgetComponent,
    RiskAnalysisAdminAndPortalWidgetComponent,
    RiskGaugeComponent,
    ActivitiesWidgetComponent,
    ActivitiesPortalWidgetComponent,
    FlexiCompliancePortalWidgetComponent,
    FlexiCompliancePortalListComponent,
    FlexiComplianceBusinessWidgetComponent,
    FlexiComplianceActionPointsWidgetComponent,
    DialogMeetingsWidgetComponent,
    ChemicalsSdsWidgetComponent,
    MyActivitiesWidgetComponent,
    MyDeviationsWidgetComponent,
    AdminNewsViewerComponent
  ],
  providers: [
    DashboardActivityResolver,
    DashboardService,
    DashboardDeviationResolver,
    DashboardRiskAnalysisResolver,
    DashboardNewsResolver,
    DashboardBusinessResolver,
    DashboardLoggedUserResolver,
    DashboardAboutKubaResolver,
    DashboardAppLoggedUserResolver,
    DashboardLinksListResolver,
    DashboardBusinessFunctionResolver,
    AboutKubaIKResolver,
    DashboardAdminNewsResolver,
    DashboardDeviationCountForUsers,
    DashboardLinksPortalBusinessResolver,
    DashboardLinksForPortalBusinessResolver,
    AppraisalMeetingService,
    AppraisalSettingsService,
    DashboardBusinessLoginResolver
  ]
})
export class DashboardModule {}
